/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * クレジットカード決済チャージ処理状態情報
 * @export
 * @interface StripePaymentChargeStatusResponseModel
 */
export interface StripePaymentChargeStatusResponseModel {
    /**
     * クレジットカード決済チャージ処理状態を表します。
     * completed : 正常完了
     * processing : チャージ処理中 (Webhookで通知がまだ来ていない状態も含みます, この状態の場合は /v1/payment/stripe/creditcardPayment を実行して状態の更新をしてください)
     * failed : 処理失敗
     * @type {string}
     * @memberof StripePaymentChargeStatusResponseModel
     */
    status?: StripePaymentChargeStatusResponseModelStatusEnum;
    /**
     * エラーコード。処理失敗時のみ返却されます
     * @type {string}
     * @memberof StripePaymentChargeStatusResponseModel
     */
    errorCode?: string;
    /**
     * エラーメッセージ。処理失敗時のみ返却されます
     * @type {string}
     * @memberof StripePaymentChargeStatusResponseModel
     */
    errorMessage?: string;
}


/**
 * @export
 */
export const StripePaymentChargeStatusResponseModelStatusEnum = {
    Completed: 'completed',
    Processing: 'processing',
    Failed: 'failed'
} as const;
export type StripePaymentChargeStatusResponseModelStatusEnum = typeof StripePaymentChargeStatusResponseModelStatusEnum[keyof typeof StripePaymentChargeStatusResponseModelStatusEnum];


/**
 * Check if a given object implements the StripePaymentChargeStatusResponseModel interface.
 */
export function instanceOfStripePaymentChargeStatusResponseModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StripePaymentChargeStatusResponseModelFromJSON(json: any): StripePaymentChargeStatusResponseModel {
    return StripePaymentChargeStatusResponseModelFromJSONTyped(json, false);
}

export function StripePaymentChargeStatusResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripePaymentChargeStatusResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'errorCode': !exists(json, 'errorCode') ? undefined : json['errorCode'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function StripePaymentChargeStatusResponseModelToJSON(value?: StripePaymentChargeStatusResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'errorCode': value.errorCode,
        'errorMessage': value.errorMessage,
    };
}

